import { useModal } from '@ebay/nice-modal-react'
import { isIOS } from 'react-device-detect'
import { Helmet } from 'react-helmet'

import pwa_ios from '../../assets/common/pwa_tutorial.mp4'
import pwa_android from '../../assets/pwa-video-tutorial/pwa_android.mp4'
import pwa_chrome_brave from '../../assets/pwa-video-tutorial/pwa_chrome_brave.mp4'
import pwa_firefox from '../../assets/pwa-video-tutorial/pwa_firefox.mp4'
import pwa_opera from '../../assets/pwa-video-tutorial/pwa_opera.mp4'
import pwa_samsung from '../../assets/pwa-video-tutorial/pwa_samsung.mp4'
import { IS_COUNTRY } from '../../constants/countries'
import useAppDownload from '../../hooks/useAppDownload'
import { useBoundStore } from '../../store/store'
import { isPWA } from '../../utils/device'
import { getBrowserName } from '../../utils/getBrowserName'
import Icon from '../icon'
import ConfirmDownload from './confirm-download'
import DefaultButton from './default-button'
import PWATutorial from './pwa-tutorial'

const tutorials = {
  chrome: pwa_chrome_brave,
  brave: pwa_chrome_brave,
  firefox: pwa_firefox,
  opera: pwa_opera,
  samsung: pwa_samsung,
  safari: pwa_ios,
}

const pwa_tutorial = tutorials[getBrowserName()]
const DownloadApp = () => {
  const downloadLinks = useAppDownload()
  const isDownloadVisible = useBoundStore(
    state => state.common.isDownloadVisible,
  )
  const setIsDownloadVisible = useBoundStore(
    state => state.common.setIsDownloadVisible,
  )
  const pwaTutorial = useModal(PWATutorial)
  const confirmDownload = useModal(ConfirmDownload)

  const handleOpenConfirmDownload = () => {
    if (confirmDownload.visible) return
    confirmDownload.show({ link: downloadLinks.android.download_link })
  }

  if (!isDownloadVisible || isPWA()) return null

  return (
    <>
      {(isIOS || IS_COUNTRY.CL) && (
        <Helmet>
          <link rel="preload" href={pwa_tutorial} as="video" />
        </Helmet>
      )}
      <div className="flx-btw-ctr pl-0 pr-4 pt-3 pb-0">
        <div className="flx-str-ctr">
          <button
            className="p-3"
            onClick={() => setIsDownloadVisible(false)}
            aria-label="To hide download modal">
            <Icon className="w-1.5 h-1.5 fill-txt" id="close" />
          </button>
          <img
            className="w-10 mr-1.5 rounded-md"
            src="/pwa-icon-180x180.webp"
            alt="App Logo"
          />
          <div>
            <p className="text-xs font-medium text-txt">
              ¡Descarga la app de FUN88 ahora!
            </p>
            <p className="text-[10px] text-secondary-txt">
              Rápido, divertido y confiable FUN88
            </p>
          </div>
        </div>
        <DefaultButton
          variant="blue"
          className="flex items-center justify-center pl-1.5 pr-1.5 py-0"
          aria-label="To view PWA tutorial"
          onClick={() => {
            if (!isIOS && downloadLinks.android.download_link) {
              // android
              window.open(downloadLinks.android.download_link, '_blank')
            } else if (isIOS && downloadLinks.ios.download_link) {
              // iOS
              window.open(downloadLinks.ios.download_link, '_blank')
            } else if ((IS_COUNTRY.CL && !isIOS) || (IS_COUNTRY.AR && !isIOS)) {
              // CL android
              pwaTutorial.show({
                pwa_tutorial: pwa_android,
                onEndedCallback: handleOpenConfirmDownload,
                withManualDownload: true,
              })
            } else {
              // Fallback
              // iOS or other countries android
              pwaTutorial.show({ pwa_tutorial })
            }
          }}>
          <svg
            width="35"
            height="35"
            viewBox="0 0 90 90"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M42.228 49.905V48.213C42.228 39.474 42.228 30.735 42.228 21.987C42.228 21.474 42.228 20.952 42.318 20.457C42.579 19.098 43.74 18.162 45.045 18.198C46.314 18.225 47.403 19.125 47.664 20.439C47.763 20.934 47.763 21.456 47.763 21.969C47.763 30.708 47.763 39.447 47.763 48.195V49.824C48.213 49.437 48.501 49.221 48.753 48.978C51.3 46.431 53.838 43.884 56.385 41.337C57.807 39.915 59.508 39.789 60.678 40.986C61.839 42.174 61.722 43.794 60.336 45.18C55.98 49.554 51.615 53.91 47.25 58.266C45.738 59.769 44.271 59.769 42.777 58.284C38.376 53.901 33.984 49.509 29.601 45.108C28.278 43.785 28.188 42.174 29.304 41.004C30.438 39.816 32.166 39.897 33.507 41.229C36.333 44.028 39.15 46.845 42.237 49.923L42.228 49.905Z"
              fill="white"
            />
            <path
              d="M44.865 70.326C36.81 70.326 28.755 70.326 20.691 70.326C18.495 70.326 17.145 68.769 17.676 66.888C18.009 65.691 18.81 64.998 20.052 64.881C20.475 64.836 20.907 64.854 21.339 64.854C37.107 64.854 52.884 64.854 68.652 64.854C71.109 64.854 72.387 65.754 72.432 67.518C72.477 69.336 71.145 70.326 68.643 70.326C60.714 70.326 52.785 70.326 44.856 70.326H44.865Z"
              fill="white"
            />
          </svg>
        </DefaultButton>
      </div>
    </>
  )
}

export default DownloadApp
